<template>
  <div>
    <!-- Needs Attention Summary -->
    <div class="row gutter-b" v-if="list != null && list.length > 0">
      <div class="col-lg-3 col-md-6">
        <div class="card card-custom card-stretch gutter-b">
          <div class="card-body d-flex align-items-center py-4">
            <div class="d-flex flex-column flex-grow-1">
              <span class="text-dark-75 font-weight-bolder font-size-lg">{{ totalDevices }}</span>
              <span class="text-muted font-weight-bold font-size-sm">Total Devices</span>
            </div>
            <span class="svg-icon svg-icon-3x svg-icon-primary">
              <inline-svg src="media/svg/icons/Devices/CPU1.svg" />
            </span>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-6">
        <div class="card card-custom card-stretch gutter-b" :class="{'border-left border-success': onlineCount > 0}">
          <div class="card-body d-flex align-items-center py-4">
            <div class="d-flex flex-column flex-grow-1">
              <span class="text-dark-75 font-weight-bolder font-size-lg">{{ onlineCount }}</span>
              <span class="text-muted font-weight-bold font-size-sm">Online</span>
            </div>
            <b-icon icon="wifi" variant="success" font-scale="2"></b-icon>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-6">
        <div class="card card-custom card-stretch gutter-b" :class="{'border-left border-danger': offlineCount > 0}">
          <div class="card-body d-flex align-items-center py-4">
            <div class="d-flex flex-column flex-grow-1">
              <span class="text-dark-75 font-weight-bolder font-size-lg">{{ offlineCount }}</span>
              <span class="text-muted font-weight-bold font-size-sm">Offline / Stale</span>
            </div>
            <b-icon icon="wifi-off" variant="danger" font-scale="2"></b-icon>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-6">
        <div class="card card-custom card-stretch gutter-b" :class="{'border-left border-warning': needsAttentionCount > 0}">
          <div class="card-body d-flex align-items-center py-4">
            <div class="d-flex flex-column flex-grow-1">
              <span class="text-dark-75 font-weight-bolder font-size-lg">{{ needsAttentionCount }}</span>
              <span class="text-muted font-weight-bold font-size-sm">Needs Attention</span>
            </div>
            <b-icon icon="exclamation-triangle" variant="warning" font-scale="2"></b-icon>
          </div>
        </div>
      </div>
    </div>

    <div class="card card-custom gutter-b">
      <div class="card-header">
        <div class="card-title">
          <h3 class="card-label">All my devices</h3>
        </div>
        <!-- Quick Filters -->
        <div class="card-toolbar" v-if="list != null && list.length > 0">
          <b-button-group size="sm">
            <b-button :variant="activeFilter === 'all' ? 'primary' : 'outline-primary'" @click="activeFilter = 'all'">
              All ({{ totalDevices }})
            </b-button>
            <b-button :variant="activeFilter === 'wifi' ? 'primary' : 'outline-primary'" @click="activeFilter = 'wifi'">
              <b-icon icon="wifi" class="mr-1"></b-icon> WiFi ({{ wifiCount }})
            </b-button>
            <b-button :variant="activeFilter === 'findmy' ? 'primary' : 'outline-primary'" @click="activeFilter = 'findmy'">
              <b-icon icon="broadcast" class="mr-1"></b-icon> FindMy ({{ findMyCount }})
            </b-button>
            <b-button :variant="activeFilter === 'attention' ? 'warning' : 'outline-warning'" @click="activeFilter = 'attention'">
              <b-icon icon="exclamation-triangle" class="mr-1"></b-icon> Needs Attention ({{ needsAttentionCount }})
            </b-button>
          </b-button-group>

          <b-button size="sm" class="ml-3" :variant="showTechnical ? 'dark' : 'outline-secondary'" @click="showTechnical = !showTechnical"
            v-b-tooltip.hover title="Show/hide token and creation date">
            <b-icon icon="gear" class="mr-1"></b-icon> Technical
          </b-button>
        </div>
      </div>
      <div class="card-body">
        <div class="d-flex justify-content-center mb-3" v-if="list == null">
          <b-spinner variant="primary"> </b-spinner>
        </div>
        <b-card v-if="list != null && list.length == 0" border-variant="warning" header="Heads up!"
          header-bg-variant="transparent" align="center">
          <b-card-text>Looks like there are no devices registered in your account
            yet.</b-card-text>
        </b-card>
        <div class="table-responsive" v-if="list != null && list.length > 0">
          <table class="table table-head-custom table-vertical-center" id="kt_advance_table_widget_1">
            <thead>
              <tr class="text-left">
                <th class="pr-0" style="width: 70px"></th>
                <th class="pr-0" style="min-width: 75px">Name</th>
                <th style="min-width: 100px">Health</th>
                <th style="min-width: 100px">Last Seen</th>
                <th style="min-width: 0px">Location</th>
                <th style="min-width: 100px" v-if="showTechnical">Creation Date</th>
                <th style="min-width: 120px" v-if="showTechnical">Token</th>
                <th class="pr-0 text-right" style="min-width: 100px">Actions</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(item, i) in filteredList">
                <tr v-bind:key="i">
                  <td class="pr-0">
                    <div class="symbol symbol-50 symbol-light mt-1">
                      <span class="symbol-label">
                        <img :src="getIconPath(item.version)" class="h-75 align-self-end" alt="" />
                      </span>
                    </div>
                  </td>

                  <td class="pl-0">
                    <a href="#" class="text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg"
                      style="text-transform: capitalize" v-on:click.prevent="goToDetails(item.version, item.token)">
                      {{ item.object }}
                    </a>
                    <span class="text-muted font-weight-bold d-block font-size-sm">
                      {{ getDeviceTypeLabel(item.version) }}
                    </span>
                    <span class="text-muted font-size-xs d-block" v-if="item.description"
                      v-b-tooltip.hover :title="item.description">
                      {{ item.description | truncate(40) }}
                    </span>
                  </td>

                  <td>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <span v-on="on" class="label label-lg label-inline font-weight-bold py-3"
                          :class="getHealthChipClass(item)">
                          {{ getHealthLabel(item) }}
                        </span>
                      </template>
                      <span>{{ getHealthTooltip(item) }}</span>
                    </v-tooltip>
                    <span class="d-block font-size-xs text-muted mt-1" v-if="getStalenessText(item)">
                      {{ getStalenessText(item) }}
                    </span>
                  </td>

                  <td>
                    <span class="font-size-xs text-muted d-block mb-1">{{ getLastSeenLabel(item) }}</span>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <span class="text-dark-75 font-weight-bold d-block" v-on="on">
                          {{ getRelativeTime(item.updated_at) }}
                        </span>
                      </template>
                      <span>{{ formatDate(item.updated_at) }}</span>
                    </v-tooltip>
                  </td>

                  <td>
                    <span class="text-muted font-weight-bold d-block">{{ item.location || '—' }}</span>
                  </td>

                  <td v-if="showTechnical">
                    <span class="text-muted font-weight-bold d-block">{{ formatDate(item.created_at) }}</span>
                  </td>

                  <td v-if="showTechnical">
                    <span class="text-muted font-weight-bold d-block font-size-xs" style="font-family: monospace;">{{ item.token }}</span>
                  </td>

                  <td class="pr-0 text-right" style="min-width: 130px; white-space: nowrap;">
                    <div class="d-flex justify-content-end">
                      <a href="#" v-on:click.prevent="copyToken(item.token)"
                        class="btn btn-icon btn-light btn-hover-primary btn-sm mr-2" v-b-tooltip.hover title="Copy token">
                        <span class="svg-icon svg-icon-md svg-icon-primary">
                          <inline-svg src="media/svg/icons/General/Clipboard.svg" />
                        </span>
                      </a>
                      <a href="#" v-on:click.prevent="goToDetails(item.version, item.token)"
                        class="btn btn-icon btn-light btn-hover-primary btn-sm mr-2" v-b-tooltip.hover title="Details">
                        <span class="svg-icon svg-icon-md svg-icon-primary">
                          <inline-svg src="media/svg/icons/Communication/Write.svg" />
                        </span>
                      </a>
                      <a href="#" v-on:click.prevent="removeDevicePrompt(item.token)"
                        class="btn btn-icon btn-light btn-hover-danger btn-sm" v-b-tooltip.hover title="Remove device">
                        <span class="svg-icon svg-icon-md svg-icon-danger">
                          <inline-svg src="media/svg/icons/General/Trash.svg" />
                        </span>
                      </a>
                    </div>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <b-modal ref="remove-device-modal" hide-footer title="Remove device">
      <div class="d-block text-center">
        <h3>You are about to unlink this device from your account</h3>
      </div>
      <b-button ref="confirm-remove-btn" class="mt-3" variant="outline-danger" block @click="removeDeviceConfirmed">Yes,
        unlink from account</b-button>
      <b-button ref="keep-remove-btn" class="mt-2" variant="outline-warning" block
        @click="closeRemovePrompt">Keep</b-button>
    </b-modal>
  </div>
</template>

<style scoped>
.label-inline {
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 0.8rem;
}
.label-light-success {
  background-color: #C9F7F5;
  color: #1BC5BD;
}
.label-light-danger {
  background-color: #FFE2E5;
  color: #F64E60;
}
.label-light-warning {
  background-color: #FFF4DE;
  color: #FFA800;
}
.label-light-info {
  background-color: #EEE5FF;
  color: #8950FC;
}
.label-light-dark {
  background-color: #D1D3E0;
  color: #3F4254;
}
.font-size-xs {
  font-size: 0.75rem;
}
.border-left {
  border-left-width: 4px !important;
}
</style>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { GET_DEVICES, DELETE_DEVICE } from "@/core/services/store/devices.module";
import { ICONS_TECHNICAL } from "@/core/enums/icons.enum";

const FINDMY_VERSIONS = ["trackerv1", "soilblessv1", "templessv1", "doorlessv1"];

const DEVICE_TYPE_LABELS = {
  sfir: "Smart Switch",
  sfir_alpha0: "Smart Switch",
  sfir_cap: "Smart Switch",
  stonev1: "Relay",
  suitchv3: "Relay",
  basicv1: "Relay",
  camv1: "Camera",
  thermostatv1: "Thermostat",
  usbthermostatv1: "USB Thermostat",
  doorv1: "Door Lock",
  valvev1: "Valve",
  seismov1: "Seismic Sensor",
  trackerv1: "FindMy Tracker",
  soilblessv1: "FindMy Soil Sensor",
  templessv1: "FindMy Temperature",
  doorlessv1: "Door/Window Sensor",
  enermonv1: "Energy Monitor",
  gpsv1: "GPS Tracker",
  bulbv1: "Smart Bulb",
};

export default {
  data() {
    return {
      list: null,
      lastSelectedDevice: "",
      activeFilter: "all",
      showTechnical: false,
      now: new Date(),
      nowInterval: null,
    };
  },

  filters: {
    truncate(text, length) {
      if (!text) return "";
      if (text.length <= length) return text;
      return text.substring(0, length) + "...";
    },
  },

  mounted() {
    this.$store.dispatch(GET_DEVICES).then((inlist) => {
      this.list = inlist;
    });
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Devices", route: "list-devices" },
      { title: "All" },
    ]);
    // Update "now" every 30 seconds so relative times stay fresh
    this.nowInterval = setInterval(() => {
      this.now = new Date();
    }, 30000);
  },

  beforeDestroy() {
    if (this.nowInterval) {
      clearInterval(this.nowInterval);
    }
  },

  computed: {
    totalDevices() {
      return this.list ? this.list.length : 0;
    },
    wifiDevices() {
      return this.list ? this.list.filter((d) => !this.isFindMy(d)) : [];
    },
    findMyDevices() {
      return this.list ? this.list.filter((d) => this.isFindMy(d)) : [];
    },
    wifiCount() {
      return this.wifiDevices.length;
    },
    findMyCount() {
      return this.findMyDevices.length;
    },
    onlineCount() {
      return this.list
        ? this.list.filter((d) => this.getHealthLevel(d) === "online").length
        : 0;
    },
    offlineCount() {
      return this.list
        ? this.list.filter((d) => {
            const h = this.getHealthLevel(d);
            return h === "offline" || h === "stale";
          }).length
        : 0;
    },
    needsAttentionCount() {
      return this.list
        ? this.list.filter((d) => this.needsAttention(d)).length
        : 0;
    },
    filteredList() {
      if (!this.list) return [];
      switch (this.activeFilter) {
        case "wifi":
          return this.list.filter((d) => !this.isFindMy(d));
        case "findmy":
          return this.list.filter((d) => this.isFindMy(d));
        case "attention":
          return this.list.filter((d) => this.needsAttention(d));
        default:
          return this.list;
      }
    },
  },

  methods: {
    getIconPath(deviceVersion) {
      return ICONS_TECHNICAL[deviceVersion];
    },
    isFindMy(device) {
      return FINDMY_VERSIONS.includes(device.version);
    },
    getDeviceTypeLabel(version) {
      return DEVICE_TYPE_LABELS[version] || "Generic";
    },
    getHoursSinceUpdate(device) {
      if (!device.updated_at) return Infinity;
      const diff = this.now - new Date(device.updated_at);
      return diff / (1000 * 60 * 60);
    },

    // --- Health logic ---
    getHealthLevel(device) {
      const hours = this.getHoursSinceUpdate(device);

      if (this.isFindMy(device)) {
        // FindMy devices
        if (device.connection_type == 1 && hours < 3) return "online";
        if (hours < 6) return "recent";
        if (hours < 24) return "stale";
        if (hours < 72) return "very-stale";
        return "offline";
      } else {
        // WiFi devices
        if (device.connection_type == 1) return "online";
        if (device.connection_type == 0) return "offline";
        return "unknown";
      }
    },
    getHealthLabel(device) {
      const level = this.getHealthLevel(device);
      if (this.isFindMy(device)) {
        switch (level) {
          case "online": return "Alive";
          case "recent": return "Recently Seen";
          case "stale": return "Stale";
          case "very-stale": return "Possibly Dead";
          case "offline": return "Unknown";
          default: return "Unknown";
        }
      } else {
        switch (level) {
          case "online": return "Online";
          case "offline": return "Offline";
          default: return "No Data";
        }
      }
    },
    getHealthChipClass(device) {
      const level = this.getHealthLevel(device);
      switch (level) {
        case "online": return "label-light-success";
        case "recent": return "label-light-info";
        case "stale": return "label-light-warning";
        case "very-stale": return "label-light-danger";
        case "offline": return "label-light-danger";
        case "unknown": return "label-light-dark";
        default: return "label-light-dark";
      }
    },
    getHealthTooltip(device) {
      const level = this.getHealthLevel(device);
      if (this.isFindMy(device)) {
        switch (level) {
          case "online": return "Device pinged recently via FindMy network";
          case "recent": return "Last seen within the past 6 hours. Likely alive but may be out of range.";
          case "stale": return "No message in the last 6-24 hours. Out of range or low coverage.";
          case "very-stale": return "No message in 1-3 days. Possibly dead battery or out of coverage.";
          case "offline": return "No message in over 3 days. Check battery or physical location.";
          default: return "No connection data available";
        }
      } else {
        switch (level) {
          case "online": return "Connected via WiFi";
          case "offline": return "Disconnected from WiFi";
          default: return "Never connected or no data yet";
        }
      }
    },
    needsAttention(device) {
      const level = this.getHealthLevel(device);
      if (this.isFindMy(device)) {
        return ["stale", "very-stale", "offline"].includes(level);
      }
      return level === "offline" || level === "unknown";
    },
    getStalenessText(device) {
      const hours = this.getHoursSinceUpdate(device);
      if (!isFinite(hours)) return "Never seen";
      if (hours < 1) return "";
      if (hours < 24) return "No message for " + Math.floor(hours) + "h";
      const days = Math.floor(hours / 24);
      return "No message for " + days + "d";
    },
    getLastSeenLabel(device) {
      if (this.isFindMy(device)) {
        return "Last data received";
      }
      if (device.connection_type == 1) {
        return "Online since";
      }
      if (device.connection_type == 0) {
        return "Offline since";
      }
      return "Last seen";
    },

    // --- Relative time ---
    getRelativeTime(dateString) {
      if (!dateString) return "Never";
      const date = new Date(dateString);
      if (isNaN(date)) return "N/A";
      const seconds = Math.floor((this.now - date) / 1000);
      if (seconds < 60) return "Just now";
      const minutes = Math.floor(seconds / 60);
      if (minutes < 60) return minutes + "m ago";
      const hours = Math.floor(minutes / 60);
      if (hours < 24) return hours + "h ago";
      const days = Math.floor(hours / 24);
      if (days < 30) return days + "d ago";
      const months = Math.floor(days / 30);
      return months + "mo ago";
    },

    formatDate(dateString) {
      if (!dateString) return "N/A";
      const options = {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      };
      try {
        const date = new Date(dateString);
        if (isNaN(date)) throw new Error("Invalid date");
        return new Intl.DateTimeFormat(undefined, options).format(date);
      } catch (err) {
        console.error("Error formatting date:", err);
        return null;
      }
    },

    copyToken(token) {
      navigator.clipboard.writeText(token).then(() => {
        this.$bvToast.toast("Token copied to clipboard", {
          title: "Copied",
          variant: "success",
          solid: true,
          autoHideDelay: 1500,
        });
      });
    },

    removeDevicePrompt(token) {
      this.lastSelectedDevice = token;
      this.$refs["remove-device-modal"].show();
    },
    removeDeviceConfirmed() {
      this.$refs["keep-remove-btn"].disabled = true;
      this.$refs["confirm-remove-btn"].disabled = true;
      const deviceToRemove = this.lastSelectedDevice;
      this.$store
        .dispatch(DELETE_DEVICE, { deviceToRemove })
        .then((result) => {
          if (result.result == "success") {
            this.$bvToast.toast("The device has been removed", {
              title: "Result",
              variant: "success",
              solid: true,
            });
            this.$store.dispatch(GET_DEVICES).then((inlist) => {
              this.list = inlist;
            });
          } else {
            this.$bvToast.toast("There was a problem removing the device", {
              title: "Result",
              variant: "danger",
              solid: true,
            });
          }
          this.$refs["remove-device-modal"].hide();
        })
        .catch(() => {
          this.$bvToast.toast("There was a problem removing the device", {
            title: "Result",
            variant: "danger",
            solid: true,
          });
        });
    },
    closeRemovePrompt() {
      this.$refs["remove-device-modal"].hide();
    },
    goToDetails(deviceVersion, token) {
      switch (deviceVersion) {
        case null:
          this.$router.push({ name: "device-generic", params: { token } });
          break;
        case "camv1":
          this.$router.push({ name: "device-camera", params: { token } });
          break;
        case "sfir":
        case "sfir_alpha0":
        case "sfir_cap":
          this.$router.push({ name: "device-sfir", params: { token } });
          break;
        case "usbthermostatv1":
        case "thermostatv1":
          this.$router.push({ name: "device-thermo", params: { token } });
          break;
        case "doorv1":
          this.$router.push({ name: "device-doorlock", params: { token } });
          break;
        case "valvev1":
          this.$router.push({ name: "device-valve", params: { token } });
          break;
        case "seismov1":
          this.$router.push({ name: "device-seismograph", params: { token } });
          break;
        case "stonev1":
        case "suitchv3":
        case "basicv1":
          this.$router.push({ name: "device-stone", params: { token } });
          break;
        case "trackerv1":
          this.$router.push({ name: "device-tracker", params: { token } });
          break;
        case "soilblessv1":
        case "templessv1":
          this.$router.push({ name: "device-soilv1", params: { token } });
          break;
        case "doorlessv1":
          this.$router.push({ name: "device-doorlessv1", params: { token } });
          break;
        case "enermonv1":
          this.$router.push({ name: "device-enermonv1", params: { token } });
          break;
      }
    },
  },
};
</script>